import { Box, styled } from '@mui/material'
import MorphButton from '@src/components/planet/detail/MorphButton'
import TradeGiftButton from '@src/components/share/trade/TradeGiftButton'
import TradeSellButton from '@src/components/share/trade/TradeSellButton'
import { FC } from 'react'

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  ${props => props.theme.breakpoints.down('res1280')} {
    justify-content: space-around;
  }
`

export const PlanetOwnerSection: FC<Props> = (props: Props) => {
  const {
    className,
    shouldShowSell,
    shouldShowGift,
    shouldShowMorph,
    isMorphEnabled,
    onSellClick,
    onGiftClick,
    onMorphClick
  } = props

  return (
    <Container className={className}>
      {shouldShowSell && <TradeSellButton onClick={onSellClick} />}
      {shouldShowGift && <TradeGiftButton onClick={onGiftClick} />}
      {shouldShowMorph && (
        <MorphButton onClick={onMorphClick} disabled={!isMorphEnabled} />
      )}
    </Container>
  )
}

export type Props = {
  className?: string
  shouldShowSell?: boolean
  shouldShowGift?: boolean
  shouldShowMorph?: boolean
  isMorphEnabled?: boolean
  onSellClick?: () => void
  onGiftClick?: () => void
  onMorphClick?: () => void
}
